import './PopupInnovatieportfolio.scss';
import { SharePage } from '../../../SharePage/SharePage';
import { Tooltip } from "../../../Tooltip/Tooltip"
import { AiOutlineClose, AiOutlineDownload } from 'react-icons/ai';
import { forEach } from 'lodash';
export const PopupInnovatieportfolio = ({ closePopupHandler, ...props }) => {
    return <div className="c-detail-fiche--innovatieportfolio">
        <div className="c-detail-fiche--innovatieportfolio__header">
            <div className="popupClosingIconContainer" onClick={() => closePopupHandler()}>
                <AiOutlineClose className="popupClosingIcon" />
            </div>
            {
                props.data?.detailBannerVideo ? <div dangerouslySetInnerHTML={{ __html: props.data?.detailBannerVideo }}></div>
                    : props.data?.detailImage && <img src={props.data.detailImage.url} alt={props.data.detailImage.alt} />
            }
        </div>
        <div className="c-detail-fiche--innovatieportfolio__body">
            <div className="c-detail-fiche--innovatieportfolio__body__title">
                <h2>{props.data.title}</h2>
            </div>
            <div>
                <p>{props.data.text}</p>
            </div>
            <div className="c-detail-fiche--innovatieportfolio__body__info">
                {
                    props.data?.detailSideBar && <ul>
                        {/* Table with: Type, innovationcluster, horizon, period, partners, budget */}
                        {
                            props.data.detailSideBar?.type?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.typeLabel} value={props.data.detailSideBar.type} tooltipText={props.dictionary.typeTooltip} />
                            </li>
                        }
                        {
                            props.data.detailSideBar?.innovationcluster?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.innovationclusterLabel} value={props.data.detailSideBar.innovationcluster} tooltipText={props.dictionary.innovationclusterTooltip} />
                            </li>
                        }
                        {
                            props.data.detailSideBar?.horizon?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.horizonLabel} value={props.data.detailSideBar.horizon} tooltipText={props.dictionary.horizonTooltip} />
                            </li>
                        }
                        {
                            props.data.detailSideBar?.period?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.periodLabel} value={props.data.detailSideBar.period} />
                            </li>
                        }
                        {
                            props.data.detailSideBar?.partners?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.partnersLabel}
                                    value={
                                        props.data.detailSideBar.partners.map((partner, i) => {
                                            return <>{`${partner}${(i + 1) < props.data.detailSideBar.partners.length ? ', ' : ''}`}</>;
                                        })
                                    } />
                            </li>
                        }
                        {
                            props.data.detailSideBar?.budget?.length > 0 && <li>
                                <InnovatieportfolioBodyInfo label={props.dictionary.budgetLabel} value={`&euro; ${props.data.detailSideBar.budget}`} />
                            </li>
                        }
                    </ul>
                }
            </div>
            {
                props.data.detailBody.intro?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__intro">
                    <p>{props.data.detailBody.intro}</p>
                </div>
            }
            {
                props.data.detailBody.description?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__description">
                    <p>{props.data.detailBody.description}</p>
                </div>
            }
            {
                props.data.detailBody.evaluation?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__property">
                    <h5>{props.dictionary.evaluationLabel}</h5>
                    <p>{props.data.detailBody.evaluation}</p>
                </div>
            }
            {
                props.data.detailBody.realisations?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__property">
                    <h5>{props.dictionary.realisationLabel}</h5>
                    <p>{props.data.detailBody.realisations}</p>
                </div>
            }
            {
                props.data.detailBody.partner?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__property">
                    <h5>{props.dictionary.partnersExtendedLabel}</h5>
                    <p>
                        {
                            props.data.detailBody.partner.map((partner, i) => {
                                return <span>{`${partner}${(i + 1) < props.data.detailBody.partner.length ? ', ' : ''}`}</span>;
                            })
                        }
                    </p>
                </div>
            }
            {
                props.data.detailBody.extraInfo?.length > 0 &&
                <div className="c-detail-fiche--innovatieportfolio__body__property">
                    <h5>{props.dictionary.extraInfoLabel}</h5>
                    <ul>
                        {
                            props.data.detailBody.extraInfo.map((link, i) => {
                                return <li>
                                    <a href={link.url} className="c-link--icon" target={link.target}>
                                        {link.title}<i class="fa fa-arrow-right" aria-hidden="true"></i>
                                    </a>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            }

            <div className="c-detail-fiche--innovatieportfolio__body__share">
                <div className="c-detail-fiche--innovatieportfolio__body__share__buttons">
                    {
                        props.data.detailBody?.link?.title &&
                        <a href={props.data.detailBody.link?.url} className="c-button c-button--block c-link--icon" target={props.data.detailBody.link.target}>
                            {props.data.detailBody.link?.title} <i class="fa-regular fa-arrow-right"></i>
                        </a>
                    }
                    {
                        props.data.detailBody?.button?.title &&
                        <a href={props.data.detailBody.button?.url} className="c-button c-button--block c-link--icon" target={props.data.detailBody.button.target}>
                            {props.data.detailBody.button?.title} <i class="fa-regular fa-arrow-right"></i>
                        </a>
                    }
                </div>
                <div className='c-detail-fiche--innovatieportfolio__body__share__social'>
                    <SharePage shareTitle={props.data.title} showLinkedIn={true} />
                </div>
            </div>
            <div className="c-detail-fiche--innovatieportfolio__footer">
                Meer weten? Contacteer <a className='fs-inherit' href={`mailto:${props.data.detailContactAddress}`}>{props.data.detailContactAddress}</a>
            </div>
        </div>
    </div>;
}


const InnovatieportfolioBodyInfo = ({ label, value, tooltipText, ...props }) => {
    return <div class="row">
        <div class="c-detail-fiche--innovatieportfolio__body__info__label col-md-6">
            {label}
        </div>
        <div class="c-detail-fiche--innovatieportfolio__body__info__value no-icon col-md-6">
            <span className='c-detail-fiche--innovatieportfolio__body__info__value__text'>
                {value}
            </span>
        </div>
        {
            tooltipText && <Tooltip
                arrowPosition={"right"}
                tooltipText={tooltipText}
            />
        }
    </div>

};